import { useFetch } from 'hooks';
import { GetBusinessInfoAISuggestionsCommand } from 'types/commands/sign-up/AISuggestionsCommand';
import { readBodySafe } from 'types/common/ApiHelpers';
import { useRef } from 'react';
import { BusinessInfoAISuggestionsResponse } from 'types';

export interface SignUpAISuggestionFunctions {
  abortRequests: () => void;
  getMerchantBusinessInfoAISuggestionsAsync: (
    payload: GetBusinessInfoAISuggestionsCommand
  ) => Promise<BusinessInfoAISuggestionsResponse | null>;
}

export const useSignUpAISuggestionFunctions =
  (): SignUpAISuggestionFunctions => {
    const { post } = useFetch();
    const abortControllerRef = useRef(new AbortController());

    function abortRequests(): void {
      abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
    }

    const getMerchantBusinessInfoAISuggestionsAsync = async (
      payload: GetBusinessInfoAISuggestionsCommand
    ): Promise<BusinessInfoAISuggestionsResponse | null> => {
      try {
        const res = await post(
          '/MerchantApplications/suggestions/business-info',
          payload,
          abortControllerRef.current.signal
        );

        const body = await readBodySafe(res);

        if (res.ok) {
          return body as BusinessInfoAISuggestionsResponse;
        }

        return null;
      } catch (error) {
        return null;
      }
    };

    return {
      abortRequests,
      getMerchantBusinessInfoAISuggestionsAsync,
    };
  };
